import { Link } from "react-router-dom";
import { ImageOff, Trash2 } from "lucide-react";
import { SafeImg } from "../../../components/common/SafeImg";
import { useI18n } from "../../../i18n";
import { fmtMoney } from "../../../lib/format";
import { QtyStepper } from "../../../components/common/QtyStepper";
import { canPieces, unitPrice } from "../../../lib/uom";
import { offerFor, useOffers } from "../../../lib/offers";

export const CartLine = ({ item, price, qty, onQty, mode = "box", onMode }) => {
  const offers = useOffers();
  const normal = unitPrice(item, price, mode);
  const o = offerFor(offers, item.code, mode, normal, qty);
  const unit = o ? o.offer_price : normal;
  const { t, lang } = useI18n();
  const photo = item?.thumb_url || item?.photos?.[0];
  if (!item || !price) {
    return (
      <li className="flex items-center gap-3 py-3 text-sm text-rose-700" data-testid="cart-line-unavailable">
        <span className="flex-1">{t("checkout.itemsUnavailable")}</span>
        <button type="button" onClick={() => onQty(0)} className="grid h-11 w-11 place-items-center rounded-full hover:bg-rose-50" aria-label={t("shop.remove")}><Trash2 className="h-4 w-4" /></button>
      </li>
    );
  }
  return (
    <li className="flex gap-3 py-3" data-testid={`cart-line-${item.code}`}>
      <Link to={`/app/products/${encodeURIComponent(item.code)}`} className="h-16 w-16 shrink-0 overflow-hidden rounded-xl bg-slate-100">
        {photo ? <SafeImg srcs={[photo, item?.detail_url, item?.photos?.[0]]} alt="" className="h-full w-full object-cover" /> : <ImageOff className="m-auto mt-5 h-5 w-5 text-slate-300" />}
      </Link>
      <div className="min-w-0 flex-1">
        <div className="flex items-start gap-2">
          <p className="line-clamp-2 flex-1 text-sm font-semibold leading-snug text-navy">{item[`name_${lang}`]}</p>
          <button type="button" onClick={() => onQty(0)} data-testid={`cart-remove-${item.code}`} aria-label={t("shop.remove")} className="-mr-2 -mt-2 grid h-11 w-11 shrink-0 place-items-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-rose-600"><Trash2 className="h-4 w-4" /></button>
        </div>
        <p className="text-xs text-slate-500">{item.code} · {o && <span className="mr-1 text-slate-400 line-through">{fmtMoney(normal)}</span>}<span className={o ? "font-semibold text-vblue-ink" : ""} data-testid={`cart-unit-${item.code}`}>{fmtMoney(unit)}</span> / {t(mode === "piece" ? "x.uom.piece" : "x.uom.box")}</p>
        <div className="mt-2 flex items-end gap-3">
          <div className="w-40"><QtyStepper value={qty} onChange={onQty} testId={`cart-qty-${item.code}`} mode={mode} onMode={canPieces(item) ? onMode : undefined} /></div>
          <span className="ml-auto pb-3 text-sm font-bold tabular-nums text-navy" data-testid={`cart-line-total-${item.code}`}>{fmtMoney(qty * unit)}</span>
        </div>
      </div>
    </li>
  );
};
